import Icon from 'core/modules/atoms/Icon';
import TextRich from 'core/modules/atoms/TextRich/TextRich';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DistributionBar from '../../atoms/DistributionBar';
import './UnitMetricsCard.scss';

/**
 * UnitMetricsCard - Displays unit metrics in horizontal layout
 */
const UnitMetricsCard = ({ unit }) => {
  const { t } = useTranslation(['chatbot']);

  // Use the alertsCount provided by the API
  const alertCount = unit.alertsCount || 0;

  return (
    <div className="unit-metrics-card">
      <div className="unit-metrics-card__info">
        <div className="unit-metrics-card__title">
          <TextRich text={unit.title} />
        </div>

        <div className={`unit-metrics-card__recommendation-tag ${alertCount === 0 ? 'unit-metrics-card__recommendation-tag--all-good' : ''}`}>
          <Icon type={alertCount === 0 ? 'thumbsup' : 'exclamation-filled'} className="unit-metrics-card__recommendation-icon" />
          <span className="unit-metrics-card__recommendation-text">
            {alertCount === 0
              ? t('analytics_expected_progress', { defaultValue: 'Progreso esperado' })
              : t('analytics_recommendations_count', { count: alertCount })}
          </span>
        </div>
      </div>

      <div className="unit-metrics-card__progress">
        <DistributionBar
          masteredPercentage={unit.kcProgressDistribution?.masteredPercentage || 0}
          inProgressPercentage={unit.kcProgressDistribution?.inProgressPercentage || 0}
          notStartedPercentage={unit.kcProgressDistribution?.notStartedPercentage || 0}
          showPercentagesAbove={true}
          showLegend={false}
        />
      </div>
    </div>
  );
};

UnitMetricsCard.propTypes = {
  unit: PropTypes.shape({
    unitId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    order: PropTypes.number,
    alertsCount: PropTypes.number,
    kcProgressDistribution: PropTypes.shape({
      masteredPercentage: PropTypes.number,
      inProgressPercentage: PropTypes.number,
      notStartedPercentage: PropTypes.number,
      totalKcs: PropTypes.number,
    }),
    lessonMetrics: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default UnitMetricsCard;
